if (!customElements.get('sticky-atc')) {

class StickyATC extends HTMLElement {

  constructor() {

    super({
      name: 'Sticky ATC',
      version: '2.0.0'
    })
  }

  connectedCallback() {

    this.buyButtons = document.querySelector('.section-main-product .pdp-buy-buttons')

    if (!this.buyButtons) return;

    this.button = this.querySelector('[data-sticky-atc-btn]')
    this.mobileButton = this.querySelector('.mobile-trigger button');
    this.colorSelector = this.querySelector('.product__color-selector')
    this.variantSelector = this.querySelector('.product__variant-selector')

    document.documentElement.style.setProperty('--footer-offset', `${this.offsetHeight}px`);

    // Mobile keeps the always-visible bar; desktop reveals it once the main
    // add-to-bag buttons scroll out of view.
    if (window.innerWidth < 750) {
      this.handleAlwaysSticky();
    } else {
      this.observer = new IntersectionObserver(this.handleUpperIntersect.bind(this), { threshold: 0 })
      this.observer.observe(this.buyButtons)
    }

    // Listeners
    this.colorSelectorDrawerListener()
    this.variantSelectorListener()

    if(this.button) {
      this.button.addEventListener('click', this.onClickHandler.bind(this));
    }

    if(this.mobileButton) {
      this.mobileButton.addEventListener('click', (event) => {
        this.onClickHandlerMobile(event);
        this.onClickHandler(event);
      });
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect()
  }

  handleAlwaysSticky() {
    document.querySelector('sticky-atc').style.transform = "translateY(0)"
    document.documentElement.classList.add('sticky-atc--visible')
    this.variantSelector?.classList.remove('active')
    this.colorSelector?.classList.remove('active')
  }

  handleUpperIntersect(entries, observer) {

    this.colorSelector = this.querySelector('.product__color-selector')
    this.variantSelector = this.querySelector('.product__variant-selector')

    entries.forEach((entry) => {

      if (entry.isIntersecting) {
        // hide when scrolling up
        document.querySelector('sticky-atc').style.transform = "translateY(calc(100% + var(--layout-space-24)))"
        document.documentElement.classList.remove('sticky-atc--visible')
        this.variantSelector?.classList.remove('active')
        this.colorSelector?.classList.remove('active')
      }else{
        // show when scrolling down
        document.querySelector('sticky-atc').style.transform = "translateY(0)"
        document.documentElement.classList.add('sticky-atc--visible')
        this.variantSelector?.classList.remove('active')
        this.colorSelector?.classList.remove('active')
      }
    })
  }


  colorSelectorDrawerListener() {
    this.colorSelector?.querySelector('.product__color-selector--wrapper').addEventListener('click', () => {
      this.colorSelector.classList.toggle('active')
      this.variantSelector?.classList.remove('active')
    })
  }

  variantSelectorListener() {
    this.variantSelector?.querySelector('.product__variant-selector--wrapper').addEventListener('click', () => {
      this.variantSelector.classList.toggle('active')
      this.colorSelector?.classList.remove('active')
    })
  }


  onClickHandler(event) {
    event.preventDefault();
    var mainAtc = document.querySelector('product-form .product-form__submit');
    if(mainAtc){
      mainAtc.click();
    }
  }

  onClickHandlerMobile(event) {
    event.preventDefault();
    // Scroll to top on mobile devices
    if (window.innerWidth < 750) {
      window.scroll({ top: 0, behavior: 'smooth' });
    }
  }

}

customElements.define('sticky-atc', StickyATC);

}
